'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import Cal, { getCalApi } from '@calcom/embed-react';
export default function CalEmbed() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Cal namespace="chat" calLink="sugarbyte/chat" style={{
      width: "100%",
      height: "100%",
      overflow: "scroll"
    }} config={{
      layout: "month_view",
      useSlotsViewOnSmallScreen: "true"
    }} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp2() {
  _temp();
}
async function _temp() {
  const cal = await getCalApi({
    namespace: "chat"
  });
  cal("ui", {
    hideEventTypeDetails: false,
    layout: "month_view"
  });
}